var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiMlService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_648_46235",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_234_920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4 0L0.400024 0V25H25.4V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_648_46235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400024 12.5L0.400025 0L12.9 5.46393e-07C12.9 6.90356 7.30359 12.5 0.400024 12.5ZM25.4 12.5C25.4 5.59645 19.8035 2.35698e-06 12.9 5.46393e-07V12.5H0.400024C0.400024 19.4035 5.99646 25 12.9 25H25.4V12.5ZM25.3951 12.5H12.9V25C12.9 18.0981 18.4938 12.5026 25.3951 12.5Z",
    fill: "#F0F0DC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMlService);
export default __webpack_public_path__ + "static/media/ai_ml_service.82e7de02455d74e20ed3e0cbc22ff6c8.svg";
export { ForwardRef as ReactComponent };